import styles from "../../styles/_containers/_forms/formPreviewModal.module.scss";

const TYPE_LABELS = {
  short_text: "תשובה קצרה",
  long_text: "תשובה מפורטת",
  date: "בחירת תאריך",
  checkbox: "תיבת סימון",
  yes_no: "כן / לא",
  single_choice: "בחירה אחת",
  multi_choice: "בחירה מרובה",
  rating: "דירוג 1-5",
};

const FormPreviewModal = ({ form, onClose }) => {
  if (!form) return null;
  const isDeclaration = form.type === "declaration";

  return (
    <div className={styles.overlay} onClick={(event) => event.target === event.currentTarget && onClose()}>
      <div className={styles.shell} role="dialog" aria-modal="true" aria-label={`תצוגה מקדימה של ${form.title}`}>
        <div className={styles.toolbar}>
          <div>
            <span className={styles.eyebrow}>תצוגה מקדימה ללקוח</span>
            <strong>{form.title}</strong>
          </div>
          <button type="button" onClick={onClose} aria-label="סגירה">×</button>
        </div>

        <div className={styles.viewport}>
          <article className={styles.paper} dir="rtl">
            <header className={styles.documentHeader}>
              <div className={styles.brandMark}><span>TOR</span>Digital</div>
              <div className={styles.documentType}>{isDeclaration ? "טופס דיגיטלי" : "שאלון דיגיטלי"}</div>
            </header>

            <div className={styles.titleBlock}>
              <span className={styles.secureBadge}>מסמך מאובטח</span>
              <h1>{form.title}</h1>
              <p>נא לעבור על הפרטים ולמלא את השדות המסומנים לפני השליחה.</p>
            </div>

            {(form.includeClientName || form.includeClientPhone) && (
              <section className={styles.clientFields}>
                {form.includeClientName && <div><span>שם מלא</span><b>שם הלקוח יופיע כאן</b></div>}
                {form.includeClientPhone && <div><span>טלפון</span><b>050-0000000</b></div>}
              </section>
            )}

            {isDeclaration ? (
              <section className={styles.declarationText}>
                {(form.content || "תוכן הטופס יופיע כאן").split("\n").map((line, index) => (
                  line ? <p key={index}>{line}</p> : <span className={styles.spacer} key={index} />
                ))}
              </section>
            ) : (
              <>
                {form.introText && <p className={styles.intro}>{form.introText}</p>}
                <section className={styles.questions}>
                  {(form.questions || []).map((question, index) => (
                    <div className={styles.question} key={question.id || index}>
                      <div className={styles.questionHeading}>
                        <span>{index + 1}</span>
                        <strong>{question.text || "שאלה ללא כותרת"}</strong>
                        {question.required && <small>חובה</small>}
                      </div>
                      <div className={styles.answerPlaceholder}>
                        {TYPE_LABELS[question.type] || "תשובה"}
                      </div>
                    </div>
                  ))}
                </section>
                {form.outroText && <p className={styles.intro}>{form.outroText}</p>}
              </>
            )}

            {form.hasSignature && (
              <section className={styles.signatureBox}>
                <div>
                  <strong>אישור וחתימה דיגיטלית</strong>
                  <span>החתימה נשמרת יחד עם מועד השליחה ופרטי האימות.</span>
                </div>
                <div className={styles.signatureLine}>חתימת הלקוח</div>
              </section>
            )}

            <footer className={styles.documentFooter}>
              <span>נוצר ומאובטח באמצעות TOR Digital</span>
              <span>הפרטים נשמרים בצורה מאובטחת</span>
            </footer>
          </article>
        </div>
      </div>
    </div>
  );
};

export default FormPreviewModal;
